// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.16.026a11.989 11.989 0 0 0-5.65 1.877C3.967 2.892 2.608 4.3 1.68 5.868a12.004 12.004 0 0 0 11.748 18.047 11.959 11.959 0 0 0 7.056-3.431c1.468-1.468 2.5-3.232 3.082-5.268.197-.692.361-1.645.4-2.334.01-.155.026-.282.038-.282.01 0 .02-.281.02-.625s-.01-.62-.02-.613c-.012.007-.029-.109-.038-.257a11.84 11.84 0 0 0-.411-2.357C22.243 4.112 18.295.703 13.536.097c-.73-.093-1.655-.12-2.376-.071m.096 1.5c-1.428.121-2.612.44-3.858 1.042a10.51 10.51 0 0 0-5.831 8.256c-.06.499-.06 1.858 0 2.352a10.52 10.52 0 0 0 5.861 8.269c1.12.536 2.125.827 3.408.988.48.06 1.848.06 2.328 0 1.319-.166 2.326-.463 3.48-1.026a10.491 10.491 0 0 0 5-5.272c.41-.96.655-1.876.789-2.959.06-.495.06-1.854 0-2.352-.326-2.67-1.527-4.956-3.533-6.73a10.49 10.49 0 0 0-4.855-2.39c-.698-.137-1.068-.172-1.913-.18a23.776 23.776 0 0 0-.876.003m6.512 4.588c-.154.055-.26.135-.398.298-.058.07-1.853 2.338-3.988 5.04-3.555 4.5-3.89 4.916-3.973 4.941-.14.042-.247-.003-.36-.154-.05-.068-.612-.864-1.249-1.768a145.565 145.565 0 0 0-1.236-1.74c-.126-.155-.298-.235-.531-.247-.17-.01-.213-.003-.326.049-.287.131-.43.34-.446.656-.009.158-.002.215.038.305.04.089 2.134 3.09 2.581 3.698.226.308.61.565.993.666.235.061.619.066.856.01.322-.074.71-.299.91-.526.225-.256 7.984-10.095 8.033-10.186a.823.823 0 0 0 .039-.563c-.109-.374-.575-.61-.943-.479M.01 12c0 .35.004.493.008.318s.004-.461 0-.636S.01 11.65.01 12"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const RatingPositiveIcon = Icon;
export default RatingPositiveIcon;
